import { Component, Input, inject } from '@angular/core';

import { NbCardModule, NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'ngx-session-timout-dialog',
  template: `
    <nb-card>
      <nb-card-header class="d-flex align-items-end">
        <div class="me-2">Session timeout. Please re-login.</div>
        <div class="fa fa-times close-btn" (click)="close()"></div>
      </nb-card-header>
    </nb-card>
  `,
  styles: [
    `
      nb-card {
        border: none;
        position: relative;
      }

      .close-btn {
        right: 0.5rem;
        top: 0.5rem;
        cursor: pointer;
        position: absolute;
        color: #0095d3;
        font-size: 1rem !important;
        margin: 0 !important;
      }
    `,
  ],
  imports: [NbCardModule],
})
export class SessionTimoutDialogComponent {
  protected dialogRef = inject<NbDialogRef<SessionTimoutDialogComponent>>(NbDialogRef);

  @Input() anyActionFlag: boolean;

  close() {
    this.dialogRef.close();
  }
}
